import { useRecoilValue, useSetRecoilState } from "recoil";
import { zoomState } from "../../states/zoomState";
import { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { userState } from "../../states/userState";

export const useZoom = () => {
  const setZoomLevel = useSetRecoilState(zoomState);
  const user = useRecoilValue(userState);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    if (user?.isAuth) {
      setZoomLevel(user.initialParameters.zoomLevel);
    } else {
      // if (isMobile || isIphone) {
      //   setZoomLevel("0.75");
      // } else {
      //   // その他のデバイスでは "1" に設定
      //   setZoomLevel("1");
      // }
      setZoomLevel("1");
    }
  }, [setZoomLevel, isMobile, isIphone, user]);
  return null;
};
